import BaseEnemyAI from "@/game/pacman/components/ai/BaseEnemyAI";
import {IEnemyAI} from "@/game/pacman/interfaces/IEnemyAI";
import Phaser from "phaser";

export default class ChaseAI extends BaseEnemyAI implements IEnemyAI {

    public getTargetPosition(x: number, y: number): Phaser.Math.Vector2 {
        return new Phaser.Math.Vector2(this.enemyInstance.playerRef.x, this.enemyInstance.playerRef.y);
    }
}